<template>
  <div
    class="image-map-container sensors_exposure"
    :id="`image-map-container-${componentConfig.id}`"
    :style="{
      backgroundImage: 'url(' + hotImgConfig.imgLink + ')',
      height: imgHeight + 'px',
    }"
    sensorsname="PictureModuleExposure"
    :sensorsdata="
      JSON.stringify({
        moduleName: `${componentConfig.sort}|${componentConfig.type}`,
        contentName: `${componentConfig.title}`,
      })
    "
  ></div>
</template>

<script>
export default {
  name: "ActivityImages",
  props: {
    componentConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columnCount: this.componentConfig.imgMaxPerLine,
      hotImgConfig: this.componentConfig.hotImgConfig,
      // hotImgConfig: {
      //     "imgLink": "https://img01.51jobcdn.com/bcopimg/20241115/bcop-activity20241115567027.png",
      //     "configList": [
      //       { "id": 1, "x": 59, "y": 92, "w": 203, "h": 203,
      //       "jumpLink": "http://10.100.51.238:8080/admin/iframe/h5activitycreate" },
      //     { "id": 2, "x": 337, "y": 656, "w": 280, "h": 180,
      //     "jumpLink": "http://10.100.51.238:8080/admin/iframe/h5activitycreate" } ]
      // },
      imgWidth: 0,
      scaleRatio: 0,
      originalHeight: 0,
      imgHeight: null, // 初始时图片高度未知
    };
  },
  computed: {
    platform() {
      return this.$store.getters.platform;
    },
  },
  created() {},
  // computed:{
  //   imgHeight(){
  //     this.$nextTick(() => {
  //       this.scaleRatio&&document.addEventListener('DOMContentLoaded', this.draw());
  //     });
  //     return this.originalHeight* this.originalWidth
  //   }
  // },
  async mounted() {
    try {
      // 假设有一个异步函数 getImageHeight 来获取图片高度
      // 注意：这个函数是假设的，你需要根据实际情况实现它
      const height = await this.getImageHeight();
      this.imgHeight = height;
      this.$nextTick(() => {
        this.$exposure.sensorsExposure();
      });

    } catch (error) {
      console.error("Failed to get image height:", error);
      // 可以设置一个默认高度或处理错误
      this.imgHeight = 150; // 例如，设置一个默认高度
    }
  },
  methods: {
    // 这是一个假设的异步函数，用于获取图片高度
    // 在实际应用中，你可能需要使用 Image 对象、Canvas 或第三方库来实现
    async getImageHeight() {
      // 这里应该是获取图片高度的异步逻辑
      // 例如，通过创建一个 Image 对象并加载图片，然后获取其高度
      // 但由于这是一个示例，我们直接返回一个模拟的高度值
      return new Promise((resolve) => {
        const img = new Image();
        img.src = this.hotImgConfig.imgLink;
        let that = this;
        img.onload = function () {
          //  ●缩放比例p = 375 / 图片宽度
          //  ●areaCoords = [X,Y,X+W,Y+H]*p
          let screenWidth =
            that.platform.indexOf("PC") > -1 ? 1200 : window.screen.width;
          that.scaleRatio = screenWidth / 750;
          that.originalWidth = screenWidth / img.width;
          that.originalHeight = img.height;
          resolve(img.height * that.originalWidth); // 假设图片高度为 300px
          that.$nextTick(() => {
            that.scaleRatio &&
              document.addEventListener("DOMContentLoaded", that.draw());
          });
        };
      });
    },
    draw() {
      const imageMapContainer = document.getElementById(`image-map-container-${this.componentConfig.id}`);
      // h: 209 id: 3 jumpLink: "https://www.json.cn/" w: 372 x: 0 y: 241
      const imageLinks = this.hotImgConfig.configList;

      imageLinks.forEach((imageLinkInfo) => {
        console.log(
          imageLinkInfo.w,
          this.scaleRatio,
          imageLinkInfo.w * this.scaleRatio,
          imageLinkInfo.h * this.scaleRatio
        );

        const aTag = document.createElement("a");
        // aTag.href = imageLinkInfo.jumpLink;
        // aTag.className = 'image-link';
        aTag.style.cssText = "display: inline-block;position: absolute;";
        aTag.style.top = `${this.size(imageLinkInfo.y)}px`;
        aTag.style.left = `${this.size(imageLinkInfo.x)}px`;
        aTag.style.width = `${this.size(imageLinkInfo.w)}px`;
        aTag.style.height = `${this.size(imageLinkInfo.h)}px`;
        // aTag.style.border = `2px solid red`;
        // aTag.textContent = imageLinkInfo.id;
        // 添加点击事件监听器
        aTag.addEventListener("click", (event) => {
          event.preventDefault(); // 阻止默认行为（即跳转）
          this.open(imageLinkInfo.jumpLink); // 调用open函数
        });
        // 你可以在这里添加其他属性或事件监听器
        imageMapContainer.appendChild(aTag);
      });
      // this.trackPictureExposure(imageMapContainer);
    },
    // 用于热区曝光
    trackPictureExposure(wrap) {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0
      };
      let observerHot = new IntersectionObserver((entries, observer) => {
        entries.forEach((item, index) => {
          if (item.isIntersecting) {
          }
        });
      }, options);

      let hotA = wrap.childNodes;
      observerHot.disconnect();
      hotA.forEach((item) => {
        observerHot.observe(item);
      });
    },
    size(info) {
      // return info*this.scaleRatio
      return info * this.scaleRatio;
    },
    open(link) {
      console.log(link, "111111111");
      // return
      if (link) {
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_image_click",
          moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
          contentName: `${this.componentConfig?.title}`,
        });
        window.location.href = link;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.image-map-container {
  position: relative;
  background-size: cover; 
  // background-position: center; /* 背景图居中 */
  background-repeat: no-repeat; /* 背景图不重复 */
  margin: 0 auto; /* 居中容器 */
  width: 100%;
  .adapt_pc_widescreen & {
    width: 1200px;
  }
  a {
    // position: absolute;
    display: block; /* 使<a>标签成为块级元素，以便设置宽度和高度 */
    width: 100px; /* 根据需要调整宽度 */
    height: 100px; /* 根据需要调整高度 */
    // z-index: 10; /* 确保<a>标签位于大图之上 */
    // text-indent: -9999px; /* 隐藏链接文本（如果需要） */
  }
}
.image-link {
  // position: absolute;
  display: block; /* 使<a>标签成为块级元素，以便设置宽度和高度 */
  width: 100px; /* 根据需要调整宽度 */
  height: 100px; /* 根据需要调整高度 */
  // z-index: 10; /* 确保<a>标签位于大图之上 */
  // text-indent: -9999px; /* 隐藏链接文本（如果需要） */
}

/* 可选的：为<a>标签添加样式以指示它们是可点击的，例如边框或背景色 */
// .image-link:hover {
//     border: 2px solid #000; /* 鼠标悬停时显示边框 */
//     background-color: rgba(0, 0, 0, 0.1); /* 鼠标悬停时显示半透明背景 */
// }
</style>
